import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';

const STORAGE_PENDING_URLS = 'checkoutPendingUrls';
const STORAGE_CURRENT_INDEX = 'checkoutCurrentIndex';

export default function CheckoutSuccess() {
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const [handled, setHandled] = useState(false);

  useEffect(() => {
    if (handled) return;

    const pendingJson = sessionStorage.getItem(STORAGE_PENDING_URLS);
    const indexStr = sessionStorage.getItem(STORAGE_CURRENT_INDEX);

    if (!pendingJson) {
      setHandled(true);
      return;
    }

    let urls;
    try {
      urls = JSON.parse(pendingJson);
    } catch {
      sessionStorage.removeItem(STORAGE_PENDING_URLS);
      sessionStorage.removeItem(STORAGE_CURRENT_INDEX);
      setHandled(true);
      return;
    }

    const currentIndex = indexStr != null ? parseInt(indexStr, 10) : 0;
    const nextIndex = currentIndex + 1;

    if (nextIndex < urls.length) {
      sessionStorage.setItem(STORAGE_CURRENT_INDEX, String(nextIndex));
      window.location.href = urls[nextIndex];
      return;
    }

    sessionStorage.removeItem(STORAGE_PENDING_URLS);
    sessionStorage.removeItem(STORAGE_CURRENT_INDEX);
    clearCart();
    setHandled(true);
  }, [clearCart, handled]);

  return (
    <div className="max-w-md mx-auto py-12 px-4 text-center">
      <div className="rounded-2xl bg-green-100 dark:bg-green-900/30 border border-green-200 dark:border-green-800 p-8">
        <h1 className="text-2xl font-semibold text-green-800 dark:text-green-200 mb-4">
          Payment complete
        </h1>
        <p className="text-lg text-green-700 dark:text-green-300">
          Paid — contact vendor for pickup.
        </p>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="mt-6 px-6 py-3 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 active:bg-indigo-800 transition-colors"
        >
          Back to marketplace
        </button>
      </div>
    </div>
  );
}
